import React from "react";
import "./css/AuthMobilePage.css";

const AuthMobilePage = () => (
  <div className="auth-mobile-container">
    <div className="auth-mobile-content">
      <div className="success-icon">✓</div>
      <h1 className="success-title">Authentication Successful!</h1>
      <p className="success-message">
        Your account has been verified and authenticated.
      </p>
      <div className="instruction-box">
        <p className="instruction-text">
          Please return to the <strong>TasteBuds app</strong> to complete your
          login.
        </p>
      </div>
    </div>
  </div>
);

export default AuthMobilePage;
